/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { FileFilter } from '../../../../types/FileFilter';
import { FileSort } from '../../../../types/FileSort';

export const FileSearchRequest: core.serialization.Schema<
    serializers.FileSearchRequest.Raw,
    Truvity.FileSearchRequest
> = core.serialization.object({
    filter: core.serialization.list(FileFilter).optional(),
    sort: core.serialization.list(FileSort).optional(),
});

export declare namespace FileSearchRequest {
    export interface Raw {
        filter?: FileFilter.Raw[] | null;
        sort?: FileSort.Raw[] | null;
    }
}
